import * as React from 'react';

const SendFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="send-fill_svg__eds-icon--send-fill"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <defs>
                <path
                    id="send-fill_svg__send-fill-polygon"
                    d="M3 20l18-8L3 4v7.1l12.6.9-12.6.9z"
                />
            </defs>
            <clipPath id="send-fill_svg__send-fill-clip-path-1">
                <use
                    xlinkHref="#send-fill_svg__send-fill-polygon"
                    overflow="visible"
                />
            </clipPath>
            <g clipPath="url(#send-fill_svg__send-fill-clip-path-1)">
                <defs>
                    <path
                        id="send-fill_svg__send-fill-rect-1"
                        d="M0 0h24v24H0z"
                    />
                </defs>
                <clipPath id="send-fill_svg__send-fill-clip-path-2">
                    <use
                        xlinkHref="#send-fill_svg__send-fill-rect-1"
                        overflow="visible"
                    />
                </clipPath>
                <path
                    clipPath="url(#send-fill_svg__send-fill-clip-path-2)"
                    d="M-2-1h28v26H-2z"
                />
            </g>
        </g>
    </svg>
);

SendFillSvg.displayName = 'SendFillSvg';
export default SendFillSvg;
